"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const radio_dispatch_1 = require("@clearsummit/radio-dispatch");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_1 = require("react-router");
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const selectors_1 = __importDefault(require("@/selectors"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const getSessionOptions = (user, getSessionPrice) => {
    const options = [
        { value: 'all', label: `All sessions - $${getSessionPrice(user, 'all')}` },
    ];
    for (let i = 1; i < user.totalMissingSessions + 1; i++) {
        options.push({
            value: i.toString(),
            label: `${i} ${i === 1 ? 'Session' : 'Sessions'} - $${getSessionPrice(user, i)}`,
        });
    }
    return options || [];
};
const PaywallSessionsScreen = ({ user, sessionCount, selectSessionCount, getSessionPrice, createPayment, pending, }) => {
    const selectRef = react_1.useRef(null);
    if (lodash_1.isEmpty(user)) {
        return react_1.default.createElement(components_1.ScreenLoader, null);
    }
    const selectOptions = getSessionOptions(user, getSessionPrice);
    const selectedOption = lodash_1.find(selectOptions, { value: sessionCount });
    const { totalMissingSessions, showPaywall } = user;
    return (react_1.default.createElement("div", { className: styles_scss_1.default.container },
        react_1.default.createElement(components_1.Meta, { title: constants_1.default.paywall.sessions.helmetTitle }),
        react_1.default.createElement("div", { className: styles_scss_1.default.contentContainer },
            react_1.default.createElement(components_1.Paper, { className: styles_scss_1.default.contentPaper },
                react_1.default.createElement("img", { src: constants_1.Images.undrawChoose, alt: "Undraw choose" }),
                react_1.default.createElement("h2", null, constants_1.default.paywall.sessions.readyToStart(showPaywall)),
                react_1.default.createElement("div", { className: styles_scss_1.default.description },
                    constants_1.default.paywall.sessions.descriptionStart(user === null || user === void 0 ? void 0 : user.sessionPrice),
                    constants_1.default.paywall.sessions.descriptionEnd),
                react_1.default.createElement("div", { className: styles_scss_1.default.sessionPickerCont },
                    react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.sessionPickerButton, title: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, ariaLabel: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, variant: "ghost", isToggle: true }),
                    react_1.default.createElement("select", { className: styles_scss_1.default.sessionPickerSelect, ref: selectRef, value: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value, onChange: event => {
                            selectSessionCount(event.target.value);
                        } }, selectOptions.map((option) => (react_1.default.createElement("option", { key: `session-${option.value}`, value: option.value }, option.label))))),
                react_1.default.createElement(components_1.Button, { className: styles_scss_1.default.continueButton, variant: "primary", title: "Continue", ariaLabel: "continue", disabled: pending, onClick: () => createPayment({
                        session_count: sessionCount === 'all' ? totalMissingSessions : sessionCount,
                    }) })))));
};
const mapStateToProps = (state) => ({
    user: selectors_1.default.user.getUser(state),
    sessionCount: selectors_1.default.payment.getSessionCount(state),
    pending: radio_dispatch_1.selectors.getPending(state, services_1.endpoints.createPayment),
});
const mapDispatchToProps = (dispatch) => ({
    selectSessionCount: (payload) => dispatch(redux_1.ActionCreators.payment.selectSessionCount.dispatch(payload)),
    getSessionPrice: (user, sessionCount) => selectors_1.default.payment.getSessionPrice(user, sessionCount),
    createPayment: data => dispatch(radio_dispatch_1.reduxSet.makeRequest.dispatch(api_payloads_1.createPaymentPayload(data))),
});
exports.default = react_router_1.withRouter(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(PaywallSessionsScreen));
